module.exports = __webpack_public_path__ + "img/ecv_nl-BE.a77f2881.svg";